import { render, staticRenderFns } from "./Member_Form.vue?vue&type=template&id=4b080bba&scoped=true&"
import script from "./Member_Form.vue?vue&type=script&lang=js&"
export * from "./Member_Form.vue?vue&type=script&lang=js&"
import style0 from "./Member_Form.vue?vue&type=style&index=0&id=4b080bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b080bba",
  null
  
)

export default component.exports